import { z } from 'zod';

export const inviteUserSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .min(1, 'Email is required')
    .email('Invalid email format')
    .transform((email) => email.trim().toLowerCase()),
});

export type InviteUserFormData = z.infer<typeof inviteUserSchema>;
